import HttpClientToken from '../../services/HttpClientToken';

import { defaultNacionalidad, NacionalidadProps } from '../../interfaces/catalogos/NacionalidadInterface';

export const Nacionalidad = () => {

    return new Promise<NacionalidadProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Nacionalidad/', token)
            .then( ({ data } : { data : NacionalidadProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerNacionalidad = () => {

    return new Promise<NacionalidadProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Nacionalidad/ObtenerNacionalidad', token)
            .then( ({ data } : { data : NacionalidadProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarNacionalidad = ( params: NacionalidadProps ) => {

    return new Promise<NacionalidadProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Nacionalidad/Actualizar', params, token)
            .then( ({ data } : { data : NacionalidadProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultNacionalidad } );
            });

        }

    });

}

export const AgregarNacionalidad = ( params: NacionalidadProps ) => {

    return new Promise<NacionalidadProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Nacionalidad/Agregar', params, token)
            .then( ({ data } : { data : NacionalidadProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultNacionalidad } );
            });

        }

    });

}
